import styled from 'styled-components';
import theme from '../../theme';

export const Wrapper = styled.div`
    height: calc(100% - 68px);
`;

export const PageContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 22.5% 1fr;
    height: 100%;
    max-width: 100%;
    grid-gap: 5px;
    margin: 0 5px;
`;

export const LeftWrapper = styled.div`
    box-shadow: #ccc 0 2px 6px 2px;
    height: calc(100% - 5px);
`;

export const LeftTopWrapper = styled.div`
    height: 50px;
    background: pink;
    display: flex;
`;

export const MainPanel = styled.div`
    position: relative;
    height: calc(100% - 5px);
    overflow: hidden;
    box-shadow: #ccc 0 2px 6px 2px;

    AolContainerComponent {
        height: calc(100% - ${theme.constants.pageHeaderHeight});
    }
    button {
        cursor: pointer;
    }
`;
